import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-message')) {
  page()
}
function page() {
  if (document.getElementById('mesDoc')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const sliderName = 'mesDoc'
    const slideItem = document.getElementById(sliderName)

    // 各要素を取得
    const mesDocSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },

      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          slidesPerView: 2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        },
      },
    })
  }
}
